import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../store';

import { BottomControlPanel, IBottomControlPanelDispatchProps, IBottomControlPanelProps } from './index';

import { toggle } from '../../store/popups/print';
import { EFeedbackComplaint, statusChanger } from '../../store/complaint/feedback_complaint';

function mapStateToProps(state: IState): IBottomControlPanelProps {
  return {
    agent: state.offerData.agent,
    docxUrl: state.offerData.offer.exportLinks.docxUrl,
    offer: state.offerData.offer,
    pdfUrl: state.offerData.offer.exportLinks.pdfUrl,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IBottomControlPanelDispatchProps {
  return {
    openPrintModal: () => dispatch(toggle(true)),
    complaintFeedbackFormStatus: (status: EFeedbackComplaint) => dispatch(statusChanger(status)),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BottomControlPanelContainer = connect<IBottomControlPanelProps, IBottomControlPanelDispatchProps, any>(
  mapStateToProps,
  mapDispatchToProps,
)(BottomControlPanel);
